module.exports = __webpack_public_path__ + "img/circles-section-features.10a0a494.png";